import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-7 gap-3" }
const _hoisted_2 = { class: "col-span-7" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = { class: "col-span-7" }
const _hoisted_6 = { class: "flex justify-end gap-3 pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Alert, { class: "col-span-7 bg-next-orange" }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Importando un sottoprogetto crerai una nuova versione dell'attuale con i dati della scelta effettuata ")
        ])),
        _: 1
      }),
      _withDirectives(_createVNode(_component_Alert, { class: "col-span-7 bg-green-700" }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("Attendi mentre recuperiamo le informazioni")
        ])),
        _: 1
      }, 512), [
        [_vShow, _ctx.$attrs.waiting]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_VueMultiselect, {
          "close-on-select": true,
          "clear-on-select": true,
          class: "next-vue-multiselect-single",
          placeholder: "Sottoprogetto",
          deselectLabel: "Deseleziona",
          selectedLabel: "Selezionato",
          selectLabel: "Seleziona",
          label: "cod_nodo",
          options: _ctx.sottoprogettoAutocomplete.options,
          onSearchChange: _ctx.sottoprogettoAutocomplete.search,
          modelValue: _ctx.sottoprogettoAutocomplete.selection,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sottoprogettoAutocomplete.selection) = $event))
        }, {
          option: _withCtx(({option}) => [
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("span", null, "Cod: " + _toDisplayString(option.cod_nodo), 1),
              _createElementVNode("span", _hoisted_4, "BU: " + _toDisplayString(option.bu_label), 1)
            ])
          ]),
          _: 1
        }, 8, ["options", "onSearchChange", "modelValue"])
      ]),
      _withDirectives(_createVNode(_component_Alert, { class: "col-span-7 bg-next-pro" }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("Non ci sono versioni manuali salvate del preventivo che si vuole importare,"),
          _createElementVNode("br", null, null, -1),
          _createTextVNode(" salvare l'ultima versione e riprovare ad importare.")
        ])),
        _: 1
      }, 512), [
        [_vShow, _ctx.sottoprogettoAutocomplete.selection && !_ctx.sottoprogettoVersioneAutocomplete.options.length]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_VueMultiselect, {
          "close-on-select": true,
          "clear-on-select": true,
          class: "next-vue-multiselect-single",
          placeholder: "Versione",
          deselectLabel: "Deseleziona",
          selectedLabel: "Selezionato",
          selectLabel: "Seleziona",
          label: "version",
          options: _ctx.sottoprogettoVersioneAutocomplete.options,
          onSearchChange: _ctx.sottoprogettoVersioneAutocomplete.search,
          modelValue: _ctx.sottoprogettoVersioneAutocomplete.selection,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sottoprogettoVersioneAutocomplete.selection) = $event))
        }, null, 8, ["options", "onSearchChange", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('chiudi'))),
        class: "w-44 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode(" Chiudi ")
        ])),
        _: 1
      }),
      _createVNode(_component_NextButton, {
        variant: "primary",
        disabled: _ctx.$attrs.waiting,
        onClick: _ctx.save,
        class: "w-44 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" Salva ")
        ])),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}